"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import { APIDataSource } from "@/components/grid/data-source";
import UiDialog from "@/components/dialog/UiDialog.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import QrcodeVue from "qrcode.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import Question from "@/components/Question.vue";
import QuestionSlot from "@/components/QuestionSlot.vue";
import DateFormat from "@/framework/timeformatter";
import EditSubAccountPower from "@/views/teamItems/components/dialog/EditSubAccountPower.vue";
import UserLoginLimit from "@/views/teamItems/components/dialog/UserLoginLimit.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import AccountBindShop from "@/views/teamItems/components/dialog/AccountBindShop.vue";
import EditSubAccount from "@/views/teamItems/components/dialog/EditSubAccount.vue";
import AccountBindVD from "@/views/teamItems/components/dialog/AccountBindVD.vue";
import MyTeamSearchForm from "./search/MyTeamSearchForm.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import BatchOperate from "./batchComponents/BatchOperate.vue";
import { CloumnListModel } from "@/models/tableModels/Tablecolumn.model";
import DisplayTeamList from "@/views/teamItems/components/DisplayTeamList.vue";
import MemberDetailDialog from "@/views/managements/teammanager/components/dialog/MemberDetailDialog.vue";
import TransferShopDialog from "@/views/managements/teammanager/components/dialog/TransferShopDialog.vue";
import HandleMumbersExcelDialog from "@/views/managements/teammanager/components/dialog/HandleMumbersExcelDialog.vue";
import CopyRuleDialog from "@/views/managements/teammanager/components/dialog/CopyRuleDialog.vue";
import AutoDeleteDialog from "@/views/managements/teammanager/components/dialog/AutoDeleteDialog.vue";
import BatchEditRoleDialog from "@/views/managements/teammanager/components/dialog/BatchEditRoleDialog.vue";
import { AccountSessionMixins } from "@/service/account-session";
import i18n from "@/lang";
import { Clipboard } from "v-clipboard";
export class AddMemberInfo extends UiFormController {
  constructor() {
    super(...arguments);
    this.user_count = 1;
    this.password_type = "random";
    this.password = null;
    this.powers = [];
    this.role = null;
    this.department = null;
    this.login_device_limit = ["WINDOWS", "MAC", "WECHAT_APP"];
    this.device_limit = "all_device_permanent";
    this.device_date = "all_date_permanent";
    this.start_time = "00:00";
    this.end_time = "23:59";
    this.loginPlatformLimits = {
      windows: true,
      mac: true,
      wechat: true,
      android: false
    };
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("addmember_info.fill_role_name"),
      trigger: "blur"
    }
  ])
], AddMemberInfo.prototype, "role", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.login_restrictions.dialog.device_limit.message"
      ),
      trigger: "blur"
    }
  ])
], AddMemberInfo.prototype, "login_device_limit", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.login_restrictions.dialog.equipment_limit.message"
      ),
      trigger: "blur"
    }
  ])
], AddMemberInfo.prototype, "device_limit", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.login_restrictions.dialog.time_limit.message"
      ),
      trigger: "blur"
    }
  ])
], AddMemberInfo.prototype, "device_date", 2);
class FormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.user_no = null;
    this.name = null;
    this.department_id = null;
    this.role_id = null;
    this.phone = null;
  }
}
let myTeamItem = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.activeName = "init";
    this.props = {
      multiple: true,
      emitPath: false,
      value: "id",
      checkStrictly: true
    };
    this.formcontroller = new FormController();
    this.searchmumbername = "";
    this.dialogLoading = false;
    this.controller = new AddMemberInfo();
    this.invite_url = "https://api.kuajingvs.com";
    // invite_url = "https://test-api.kuajingvs.com";
    this.formatter = DateFormat;
    this.arr_list = [];
    this.team_list_new = [];
    this.show_team_list = false;
    this.ColumnList = new CloumnListModel();
    this.role_options = [];
    this.all_department = [];
    this.choose_shops = [];
    this.submit_loading = false;
    this.team_list = [
      {
        key: "department",
        prop: "",
        label: this.$t("team_management.my_team.table.department"),
        sortable: false,
        scoped: true,
        width: "180",
        header: false
      },
      {
        key: "vd_count",
        prop: "vd_count",
        label: this.$t("team_management.my_team.table.vd"),
        sortable: false,
        scoped: true,
        width: "60",
        header: false
      },
      {
        key: "shop_count",
        prop: "shop_count",
        label: this.$t("team_management.my_team.table.shop"),
        sortable: false,
        scoped: true,
        width: "70",
        header: false
      },
      {
        key: "phone",
        prop: "",
        label: this.$t("team_management.my_team.table.phone"),
        sortable: false,
        scoped: true,
        width: this.$i18n.locale === "zh-CN" ? "" : "150",
        header: false
      },
      {
        key: "login_limit",
        prop: "",
        label: this.$t("team_management.my_team.table.auth_method"),
        sortable: false,
        scoped: true,
        width: "140",
        header: false
      },
      {
        key: "device_acthorize_count",
        prop: "",
        label: this.$t("team_management.my_team.table.device_acthorize_count"),
        sortable: false,
        scoped: true,
        width: "90",
        header: false
      },
      {
        key: "last_login_time",
        prop: "",
        label: this.$t("team_management.my_team.table.last_login_time"),
        sortable: false,
        scoped: true,
        width: "",
        header: false
      },
      {
        key: "lock",
        prop: "",
        label: this.$t("team_management.my_team.table.locked"),
        sortable: false,
        scoped: true,
        width: this.$i18n.locale === "zh-CN" ? "60" : "80",
        header: false
      }
    ];
    this.batchOperates = new Map(
      function* () {
        yield [
          "batch-login-limit",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchLoginLimit.vue").default
        ];
        yield [
          "batch-edit-role",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchEditRoles.vue").default
        ];
        yield [
          "batch-department",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchDepartmentEdit.vue").default
        ];
        yield [
          "batch-rules",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchRules.vue").default
        ];
        yield [
          "batch-shop",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchShopEdit.vue").default
        ];
        yield [
          "cancel-all-shops",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchCancelShops.vue").default
        ];
        yield [
          "batch-admin",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchAdminEdit.vue").default
        ];
        yield [
          "cancel-all-admin",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchCancelAdmin.vue").default
        ];
        yield [
          "batch-change-password",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchChangePassword.vue").default
        ];
        yield [
          "batch-remove-phone-bind",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchRemovePhone.vue").default
        ];
        yield [
          "batch-lock-member",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchLockMember.vue").default
        ];
        yield [
          "batch-unlock-member",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchUnlockMember.vue").default
        ];
        yield [
          "batch-delete",
          require("@/views/managements/teammanager/components/teamItembatchComponents/BatchDelete.vue").default
        ];
      }()
    );
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v8/users")
    );
    this.shop_powers = [
      {
        key: "SHOP_CREATE",
        name: this.$t("team_management.other_way.dialog.shop_create")
      },
      {
        key: "SHOP_EDIT",
        name: this.$t("team_management.action_power.shop_edit")
      },
      {
        key: "SELECT_SHOP_PASSWORD",
        name: this.$t("team_management.other_way.dialog.select_shop_password")
      },
      {
        key: "DELETE_CACHE",
        name: this.$t("team_management.other_way.dialog.delete_save")
      },
      {
        key: "VIDEO_AUTH",
        name: this.$t("team_management.action_power.dialog.add_video")
      },
      {
        key: "COOKIE_BACKUP",
        name: this.$t("team_management.other_way.dialog.cookie_backup")
      },
      {
        key: "SHOW_LAST_LOGIN",
        name: this.$t("team_management.other_way.dialog.show_last_login")
      },
      {
        key: "SHOW_SHOP_AUTH_COUNT",
        name: this.$t("team_management.other_way.dialog.show_shop_auth_count")
      },
      {
        // cookie导入权限
        key: "IMPORT_COOKIE",
        name: this.$t("team_management.other_way.dialog.cookie_import_power")
      },
      {
        key: "VD_NAME_INVISIBLE",
        name: this.$t("team_management.other_way.dialog.not_vd_name_invisible"),
        question: this.$t(
          "team_management.other_way.dialog.vd_name_invisible_question"
        )
      },
      // {
      //   key: "VD_LIST_MODE_INVISIBLE",
      //   name: this.$t("team_management.other_way.dialog.vd_list_mode"),
      // },
      {
        key: "NOT_VD_LIST_MODE_INVISIBLE",
        name: this.$t("team_management.other_way.dialog.not_vd_list_mode"),
        question: this.$t(
          "team_management.other_way.dialog.not_vd_list_mode_question"
        )
      },
      {
        key: "PLUG_MANAGEMENT_PERSON",
        name: this.$t("team_management.action_power.dialog.extensions_install"),
        question: this.$t(
          "team_management.action_power.dialog.extensions_install_question"
        )
      },
      {
        key: "PLUG_MANAGEMENT",
        name: this.$t("team_management.action_power.dialog.extensions_manager"),
        question: this.$t(
          "team_management.action_power.dialog.extensions_manager_question"
        )
      }
    ];
    this.team_powers = [
      // {
      //   key: "FORBIDDEN_AUTH_VD_MANAGER",
      //   name: this.$t(
      //     "team_management.other_way.dialog.forbidden_auth_vd_manager"
      //   ),
      // },
      {
        key: "NOT_FORBIDDEN_AUTH_VD_MANAGER",
        name: this.$t(
          "team_management.other_way.dialog.not_forbidden_auth_vd_manager"
        ),
        question: this.$t(
          "team_management.other_way.dialog.not_forbidden_auth_vd_manager_question"
        )
      },
      // {
      // key: "ADMIN_DISALLOW_MODIFY_SELF_POWER",
      // name: this.$t(
      //   "team_management.other_way.dialog.admin_disallow_modify_self_power"
      // ),
      // },
      // {
      //   key: "NOT_ADMIN_DISALLOW_MODIFY_SELF_POWER",
      //   name: this.$t(
      //     "team_management.other_way.dialog.not_admin_disallow_modify_self_power"
      //   ),
      //   question: this.$t(
      //     "team_management.other_way.dialog.not_admin_disallow_modify_self_power_question"
      //   ),
      // },
      {
        key: "PASSWORD_EDIT",
        name: this.$t("team_management.other_way.dialog.allow_edit")
      },
      {
        key: "TEAM_LOGIN_SETTING",
        name: this.$t("team_management.other_way.dialog.show_team_login")
      },
      {
        key: "TEAM_LOGIN_APPROVAL",
        name: this.$t("team_management.other_way.dialog.team_login_management")
      },
      {
        key: "ACCESS_CONTROL_SETTING",
        name: this.$t("team_management.other_way.dialog.setting_access_control")
      },
      {
        key: "ACCESS_CONTROL_APPROVAL",
        name: this.$t("team_management.other_way.dialog.access_control_approval")
      },
      {
        key: "IN_PROCESS_MONITORING_SETTING",
        name: this.$t(
          "team_management.other_way.dialog.inprogress_supervision_setting"
        )
      },
      {
        key: "IN_PROCESS_MONITORING_APPROVAL",
        name: this.$t(
          "team_management.other_way.dialog.inprogress_supervision_approval"
        )
      }
    ];
    this.cost_powers = [
      {
        key: "VD_NEW",
        name: this.$t("team_management.other_way.dialog.vd_new")
      },
      {
        key: "VD_RENEW",
        name: this.$t("team_management.other_way.dialog.vd_renew")
      },
      {
        key: "RECHARGE_COIN",
        name: this.$t("team_management.other_way.dialog.recharge_coin_power")
      },
      {
        key: "COIN_DETAIL",
        name: this.$t("team_management.other_way.dialog.coin_info")
      },
      {
        key: "VIEW_ORDER_DETAIL",
        name: this.$t("team_management.other_way.dialog.view_order_detail")
      },
      {
        key: "VD_UPGRADE",
        name: this.$t("team_management.other_way.dialog.vd_upgrade")
      },
      {
        key: "INVOICE_MANAGEMENT",
        name: this.$t("team_management.other_way.dialog.invoice_management")
      }
    ];
    this.service_powers = [
      {
        key: "OPEN_API",
        name: this.$t("team_management.action_power.open_api")
      }
    ];
    this.selectDatas = [];
    this.selected_department_ids = [];
    this.regulationMode = "SHOP";
    this.searchParams = {
      search: {},
      select: null
    };
    this.adduserLock = _.debounce((data) => __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v7/accounts/user/${data.guid}/lock`, {
          lock: data.lock
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    }), 500);
    this.searchName = _.debounce((data) => __async(this, null, function* () {
      if (data !== null && data !== "") {
        this.searchParams.search = {
          name: data,
          account: data
        };
      }
      if (data === null || data === "") {
        this.searchParams.search = {};
      }
      this.gridController.query.current = 1;
      this.gridController.query.params = this.searchParams;
      yield this.gridController.search();
    }), 500);
    this.onCopy = _.debounce((e) => {
      this.$message.success(
        this.$t("team_management.add_member.copy_success")
      );
    }, 500);
  }
  get checkselect() {
    return (item) => {
      let flag = false;
      for (let _id of this.selected_department_ids) {
        if (_id === item.id) {
          flag = true;
          break;
        }
      }
      return flag;
    };
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.GetColumnList();
      yield this.getSettings();
      this.gridController.query.params = this.searchParams;
    });
  }
  // 获取监管模式
  getSettings() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/regulation-config`);
        this.regulationMode = response.data.regulationMode;
      } catch (error) {
      }
    });
  }
  clearBatch() {
    this.selectDatas = [];
    this._grid_table.clearSelection();
  }
  GetColumnList() {
    return __async(this, null, function* () {
      this.show_team_list = false;
      this.team_list_new = [];
      let response = yield API.get(
        `api://base.auth/api/v8/columns`,
        {
          params: {
            type: "team"
          }
        }
      );
      this.ColumnList = response.data;
      let arr = [];
      for (let item of response.data.columns) {
        if (item.columon !== "operation" && item.columon !== "name" && item.columon !== "number" && item.is_show) {
          let _item = _.find(this.team_list, { key: `${item.columon}` });
          if (_item !== void 0) {
            arr.push(_item);
          }
        }
      }
      this.team_list_new = this.team_list;
      this.show_team_list = true;
    });
  }
  getShops(item) {
    if (item.length > 0) {
      let arr = [];
      for (let data of item) {
        arr.push(data.label);
      }
      return arr.join(",");
    }
    return this.$t("virtualdesktopform.choose_users");
  }
  openSplitShop() {
    this._edit_bind_shop.open_new(this.choose_shops);
  }
  setShops(datas) {
    this.choose_shops = datas.datas;
  }
  editRoles() {
    return __async(this, null, function* () {
      try {
        this._batch_edit_role_dialog.open(this.selectDatas);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  openHandleMumbersExcel() {
    return __async(this, null, function* () {
      try {
        this._handle_dialog.open();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  addTeamMumbers() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v7/team/invite`);
        this.invite_url = response.data.url;
        let result = yield API.get(`api://base.auth/api/v1/roles/list`);
        this.role_options = result.data.datas;
        let item = _.find(this.role_options, { code: "ROLE_STAFF", type: "org" });
        if (item) {
          console.log(item);
          this.controller.role = item.guid;
        } else {
          this.controller.role = result.data.datas[0].guid;
        }
        let department_response = yield API.get(
          `api://base.auth/api/v1/departments`
        );
        let arr = [];
        arr.push(department_response.data);
        arr = yield this.formatdata(arr);
        this.all_department = arr;
        this.controller.powers = [
          "DELETE_CACHE",
          "VIDEO_AUTH",
          "COOKIE_BACKUP",
          "SHOW_LAST_LOGIN",
          "SHOW_SHOP_AUTH_COUNT",
          "NOT_VD_LIST_MODE_INVISIBLE",
          "PLUG_MANAGEMENT_PERSON",
          "FORBIDDEN_AUTH_VD_MANAGER"
          // "ADMIN_DISALLOW_MODIFY_SELF_POWER"
        ];
        this._add_members_dialog.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  InviteMumbers() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v7/team/invite`);
        this.invite_url = response.data.url;
        let result = yield API.get(`api://base.auth/api/v1/roles`);
        this.role_options = result.data.datas;
        this.controller.role = result.data.datas[0].guid;
        let department_response = yield API.get(
          `api://base.auth/api/v1/departments`
        );
        let arr = [];
        arr.push(department_response.data);
        arr = yield this.formatdata(arr);
        this.all_department = arr;
        this._invite_members_dialog.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  formatdata(data) {
    return __async(this, null, function* () {
      for (let item of data) {
        if (item.hasOwnProperty("children") === false) {
          continue;
        }
        if (item.children === null) {
          delete item.children;
          continue;
        }
        if (item.children.length === 0) {
          delete item.children;
          continue;
        }
        if (item.children !== void 0 && item.children.length > 0) {
          this.formatdata(item.children);
        }
      }
      return data;
    });
  }
  openDisplayDialog() {
    return __async(this, null, function* () {
      yield this._display_team_list.open();
    });
  }
  toDeviceSearch(item) {
    const fullpath = this.$router.resolve(`/team?name=${item.name}&tab=pass`);
    window.open(fullpath.href, "__blank");
  }
  changeMoveSelected(data) {
    return __async(this, null, function* () {
      console.log(data);
      if (this.arr_list.length === 0) {
        return;
      }
      if (data.status_flag) {
        data.status_flag = !data.status_flag;
      } else {
        data.status_flag = true;
      }
      let flag = false;
      for (let id of this.selected_department_ids) {
        if (id === data.id) {
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.selected_department_ids.push(data.id);
      }
      if (flag) {
        this.selected_department_ids.splice(
          this.selected_department_ids.findIndex((e) => e === data.id),
          1
        );
      }
    });
  }
  openHtml() {
    window.open(`https://www.kuajingvs.com/help/5554`);
  }
  formatDepartment(data) {
    let arr = [];
    for (let item of data) {
      arr.push(item.name);
    }
    return arr.join(",");
  }
  searchQuery(query) {
    return __async(this, null, function* () {
      this.searchParams.search = query.params;
      this.gridController.query.params = this.searchParams;
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  showRightDrawer() {
    return __async(this, null, function* () {
      if (this.searchmumbername !== "" && this.searchmumbername !== null) {
        yield this.clearSearchQuery();
      }
      const _advancedSearchForm = MyTeamSearchForm.create(this.formcontroller);
      _advancedSearchForm.$on("search", this.searchQuery);
      _advancedSearchForm.show();
    });
  }
  clearSearchQuery() {
    return __async(this, null, function* () {
      this.searchmumbername = "";
      this.formcontroller = new FormController();
      this.gridController.query.params = {
        search: {},
        select: null
      };
      yield this.gridController.search();
    });
  }
  loginimit() {
    return __async(this, null, function* () {
      try {
        this._login_limit.open(this.selectDatas);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  batchVd() {
    return __async(this, null, function* () {
      try {
        this._edit_bind_vd.open(this.selectDatas);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  editDepartment() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/departments`);
        let arr = [];
        arr.push(response.data);
        yield this.formatData(arr, 0);
        this._edit_department.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  formatData(data, i) {
    return __async(this, null, function* () {
      if (i === 0 && this.arr_list.length > 0) {
        this.arr_list = [];
      }
      for (let item of data) {
        item.level = i + 1;
        this.arr_list.push(item);
        if (item.hasOwnProperty("children") && item.children.length > 0) {
          yield this.formatData(item.children, i + 1);
        }
      }
    });
  }
  editrules() {
    return __async(this, null, function* () {
      this._edit_power.open(this.selectDatas);
    });
  }
  editShop() {
    return __async(this, null, function* () {
      try {
        this._edit_bind_shop.open(this.selectDatas);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  submit() {
    return __async(this, null, function* () {
      if (this.controller.password_type === "value") {
        if (this.controller.password === null || this.controller.password === "") {
          this.$message.error(
            this.$i18n.t("register.password_trigger_tip2")
          );
          return;
        }
        let runoob = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,24}$/;
        if (!runoob.test(this.controller.password)) {
          this.$message.error(
            this.$i18n.t("register.password_trigger_tip3")
          );
          return;
        }
      }
      try {
        this.submit_loading = true;
        let shop_ids = [];
        if (this.choose_shops.length > 0) {
          for (let item of this.choose_shops) {
            shop_ids.push(item.id);
          }
        }
        if (!this.controller.powers.includes("NOT_VD_LIST_MODE_INVISIBLE")) {
          if (!this.controller.powers.includes("VD_LIST_MODE_INVISIBLE")) {
            this.controller.powers.push("VD_LIST_MODE_INVISIBLE");
          }
        } else {
          this.controller.powers = this.controller.powers.filter(
            (power) => power !== "VD_LIST_MODE_INVISIBLE"
          );
          this.controller.powers = this.controller.powers.filter(
            (power) => power !== "NOT_VD_LIST_MODE_INVISIBLE"
          );
        }
        if (!this.controller.powers.includes("NOT_FORBIDDEN_AUTH_VD_MANAGER")) {
          if (!this.controller.powers.includes("FORBIDDEN_AUTH_VD_MANAGER")) {
            this.controller.powers.push("FORBIDDEN_AUTH_VD_MANAGER");
          }
        } else {
          this.controller.powers = this.controller.powers.filter(
            (power) => power !== "FORBIDDEN_AUTH_VD_MANAGER"
          );
          this.controller.powers = this.controller.powers.filter(
            (power) => power !== "NOT_FORBIDDEN_AUTH_VD_MANAGER"
          );
        }
        if (this.controller.login_device_limit.includes("WECHAT_APP")) {
          this.controller.loginPlatformLimits.wechat = true;
        } else {
          this.controller.loginPlatformLimits.wechat = false;
        }
        if (this.controller.login_device_limit.includes("ANDROID")) {
          this.controller.loginPlatformLimits.android = true;
        } else {
          this.controller.loginPlatformLimits.android = false;
        }
        if (this.controller.login_device_limit.includes("WINDOWS")) {
          this.controller.loginPlatformLimits.windows = true;
        } else {
          this.controller.loginPlatformLimits.windows = false;
        }
        if (this.controller.login_device_limit.includes("MAC")) {
          this.controller.loginPlatformLimits.mac = true;
        } else {
          this.controller.loginPlatformLimits.mac = false;
        }
        const response = yield API.post(
          // `api://base.auth/api/v1/accounts/create_users`,
          `api://base.auth/api/v8/accounts/users`,
          {
            login_limit: {
              date_limit: this.controller.device_date,
              device_limit: this.controller.device_limit,
              end_time_limit: this.controller.end_time,
              start_time_limit: this.controller.start_time
            },
            password: this.controller.password,
            password_type: this.controller.password_type,
            powers: this.controller.powers,
            user_count: this.controller.user_count,
            role: this.controller.role,
            departments: this.controller.department,
            shops: shop_ids,
            loginPlatformLimits: this.controller.loginPlatformLimits
          }
        );
        this.$message.success(
          this.$t("team_management.other_way.dialog.success")
        );
        this.controller.user_count = 1;
        this.controller.password_type = "random";
        this.controller.password = null;
        this.controller.powers = [];
        this.controller.role = null;
        this.controller.department = null;
        this.controller.device_limit = "all_device_permanent";
        this.controller.device_date = "all_date_permanent";
        this.controller.start_time = "00:00";
        this.controller.end_time = "23:59";
        this.controller.login_device_limit = ["WINDOWS", "MAC", "WECHAT_APP"];
        this.controller.loginPlatformLimits = {
          windows: true,
          mac: true,
          wechat: true,
          android: false
        };
        this.submit_loading = false;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
        this.submit_loading = false;
      } finally {
        this.close();
      }
    });
  }
  editUser(data) {
    this._edit_subaccount.open(data);
  }
  checked_memebers_move() {
    return __async(this, null, function* () {
      try {
        let response = yield API.post(
          `api://base.auth/api/v1/user/department/batch`,
          {
            departments: this.selected_department_ids,
            users: ((selectItems) => {
              let items = [];
              for (let item of selectItems) {
                items.push(item.guid);
              }
              return items;
            })(this.selectDatas)
          }
        );
        this.close_move_members();
        this.$message.success(
          this.$t(
            "team_management.adjustment_department.dialog.success_message"
          )
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changePasswordType() {
    console.log(123);
    this.controller.password_type = "value";
  }
  handleCommand(command) {
    return __async(this, null, function* () {
      switch (command.path) {
        case "copy-pwd":
          try {
            let account = command.method.account;
            let password = command.method.original_password;
            let copy_data = this.$t("team_management.copy_account_and_pwd_tip1") + command.method.name + "\n" + this.$t("team_management.copy_account_and_pwd_tip3") + account + "\n" + this.$t("team_management.copy_account_and_pwd_tip2") + password;
            Clipboard.copy(copy_data);
            this.$message.success(
              this.$t("team_management.copy_account_and_pwd.success")
            );
          } catch (error) {
            if (error.hasOwnProperty("response")) {
              this.$message.error(error.response.data.errors.datas[0].message);
            }
          }
          break;
        case "transfer_shop":
          this._transfer_dialog.open(command.method);
          break;
        case "member_detail":
          this._member_detail.open(command.method);
          break;
        case "login-limit":
          try {
            let arr2 = [];
            arr2.push(command.method);
            this._login_limit.open(arr2);
          } catch (error) {
            if (error.hasOwnProperty("response")) {
              this.$message.error(error.response.data.errors.datas[0].message);
            }
          }
          break;
        case "rule-options":
          let arr = [];
          arr.push(command.method);
          this._edit_power.open(arr);
          break;
        case "copy-rule":
          this._copy_rule_dialog.open(command.method);
          break;
        case "delete":
          let _ids = [];
          yield UiConfirm.confirm(
            `${this.$t("team_management.delete_subcount.message", {
              name: command.method.name
            })}<br/>
        ${this.$t("main.after_delete_message")}
        `,
            this.$t("team_management.delete_subcount.title"),
            {
              dangerouslyUseHTMLString: true,
              roundButton: true,
              confirmButtonText: this.$t(
                "team_management.delete_subcount.confirm"
              ),
              cancelButtonText: this.$t(
                "team_management.delete_subcount.cancel"
              ),
              confirmButtonClass: "btn-orange"
            }
          );
          let guid = command.method.guid;
          _ids.push(guid);
          yield API.post(`api://base.auth/api/v1/users/delete_users`, {
            user_guid_list: _ids
          });
          this.$message.success(this.$t("main.delete_message_success"));
          yield this.refresh();
          break;
        case "open-shop":
          yield this.open_shop_count(command.method);
          break;
        case "auto-delete":
          this.openAutoDeleteDialog(command.method);
          break;
        case "close-auto-delete":
          yield this.closeAutoDelete(command.method);
          break;
        case "close-shop-monitor":
          yield this.closeShopMonitor(command.method);
          break;
        case "open-shop-monitor":
          yield this.openShopMonitor(command.method);
          break;
      }
    });
  }
  // 关闭成员监管
  closeShopMonitor(row) {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(row.guid);
        yield API.put(
          `api://base.auth/api/v1/monitor/resource-bindings/USER/close`,
          {
            resourceIds: arr
          }
        );
        this.$message.success(
          this.$t(
            "team_management.my_team.table.close_shop_monitor_success"
          )
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 开启成员监管
  openShopMonitor(row) {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(row.guid);
        yield API.post(`api://base.auth/api/v1/monitor/resource-bindings/USER`, {
          resourceIds: arr
        });
        this.$message.success(
          this.$t(
            "team_management.my_team.table.open_shop_monitor_success"
          )
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 开启定时删除的选择框
  openAutoDeleteDialog(data) {
    this._auto_delete_dialog.open(data);
  }
  // 关闭定时删除
  closeAutoDelete(data) {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.confirm(
          this.$t("auto_delete.close_delete_tip"),
          this.$t("auto_delete.close_delete_title"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            cancelButtonText: this.$t("headertoolbar.cancel")
          }
        );
        yield API.delete(
          `api://base.auth.pro/v1/scheduled-deletion-user/${data.guid}/cancel`
        );
        this.$message.success(
          this.$t("auto_delete.close_delete_success")
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  open_shop_count(data) {
    let arr = [];
    arr.push(data);
    this._edit_bind_shop.open(arr);
  }
  open_vd_count(data) {
    let arr = [];
    arr.push(data);
    this._edit_bind_vd.open(arr);
  }
  closeaddDialog() {
    return __async(this, null, function* () {
      this._add_members_dialog.hide();
      this.controller.user_count = 1;
      this.controller.role = null;
      this.controller.department = null;
      this.controller.device_limit = "all_device_permanent";
      this.controller.device_date = "all_date_permanent";
      this.controller.start_time = "00:00";
      this.controller.end_time = "23:59";
      this.controller.password = null;
      this.controller.powers = [];
      this.controller.password_type = "random";
    });
  }
  closeInviteDialog() {
    return __async(this, null, function* () {
      this._invite_members_dialog.hide();
    });
  }
  close() {
    return __async(this, null, function* () {
      this._add_members_dialog.hide();
      this.controller.password_type = "random";
      this.controller.password = null;
      this.choose_shops = [];
      this.controller.powers = [];
      yield this.refresh();
    });
  }
  gridSort(data) {
    return __async(this, null, function* () {
      yield this.gridController.search();
    });
  }
  refresh() {
    return __async(this, null, function* () {
      this.gridController.query.params = this.searchParams;
      yield this.GetColumnList();
      yield this.gridController.search();
    });
  }
  selectItems(items) {
    this.selectDatas = items;
  }
  close_move_members() {
    this.selected_department_ids = [];
    this.arr_list = [];
    this._edit_department.hide();
  }
  formatDate(time) {
    if (!time || time === null || time === 0) {
      return "--";
    } else {
      return DateFormat.dateformat(DateFormat.check(time));
    }
  }
  goHelp(no) {
    window.open(`https://www.kuajingvs.com/help2/${no}`);
  }
};
__decorateClass([
  Ref("add-members-dialog")
], myTeamItem.prototype, "_add_members_dialog", 2);
__decorateClass([
  Ref("invite-members-dialog")
], myTeamItem.prototype, "_invite_members_dialog", 2);
__decorateClass([
  Ref("edit-power")
], myTeamItem.prototype, "_edit_power", 2);
__decorateClass([
  Ref("login-limit")
], myTeamItem.prototype, "_login_limit", 2);
__decorateClass([
  Ref("bind-shop")
], myTeamItem.prototype, "_edit_bind_shop", 2);
__decorateClass([
  Ref("edit-sub-account")
], myTeamItem.prototype, "_edit_subaccount", 2);
__decorateClass([
  Ref("edit-department")
], myTeamItem.prototype, "_edit_department", 2);
__decorateClass([
  Ref("bind-vd")
], myTeamItem.prototype, "_edit_bind_vd", 2);
__decorateClass([
  Ref("grid-table")
], myTeamItem.prototype, "_grid_table", 2);
__decorateClass([
  Ref("display-team-list")
], myTeamItem.prototype, "_display_team_list", 2);
__decorateClass([
  Ref("member-detail")
], myTeamItem.prototype, "_member_detail", 2);
__decorateClass([
  Ref("transfer-dialog")
], myTeamItem.prototype, "_transfer_dialog", 2);
__decorateClass([
  Ref("handle-dialog")
], myTeamItem.prototype, "_handle_dialog", 2);
__decorateClass([
  Ref("copy-rule-dialog")
], myTeamItem.prototype, "_copy_rule_dialog", 2);
__decorateClass([
  Ref("auto-delete-dialog")
], myTeamItem.prototype, "_auto_delete_dialog", 2);
__decorateClass([
  Ref("batch-edit-role-dialog")
], myTeamItem.prototype, "_batch_edit_role_dialog", 2);
myTeamItem = __decorateClass([
  Component({
    components: {
      QrcodeVue,
      UiDialog,
      UiForm,
      UiSubmit,
      UiGrid,
      Question,
      QuestionSlot,
      EditSubAccountPower,
      UserLoginLimit,
      PasswordInput,
      AccountBindShop,
      EditSubAccount,
      AccountBindVD,
      BatchOperate,
      DisplayTeamList,
      MemberDetailDialog,
      TransferShopDialog,
      HandleMumbersExcelDialog,
      CopyRuleDialog,
      AutoDeleteDialog,
      BatchEditRoleDialog
    }
  })
], myTeamItem);
export {
  myTeamItem as default
};
